<template>
	<div>
		<v-list-item
				class="primary--text"
				dense
				:ripple="false"
				:href="data?.href"
		>
			<v-list-item-icon class="ms-n1">
				<v-icon>{{ data.icon }}</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title class="text-body-2">
					{{ data.name }}
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>

		<v-divider class="my-2 opacity-70"></v-divider>
	</div>
</template>

<script>
export default {
	name: 'Breadcrumb',
	components: {},
	props: {
		data: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {};
	},
	computed: {},
	methods: {}
};
</script>

<style lang="scss" scoped>
.v-list-item {
	&--link:before {
		background: none !important;
	}

	&__subtitle {
		overflow: initial;
		text-overflow: initial;
		white-space: initial;
	}
}
</style>